import { render, staticRenderFns } from "./dui-dropdown-option.vue?vue&type=template&id=08059d46&"
import script from "./dui-dropdown-option.vue?vue&type=script&lang=js&"
export * from "./dui-dropdown-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports